module.exports = __webpack_public_path__ + "img/annie-spratt-unsplash_sized.9f8556a6.jpeg";